<template>
  <div class="section">
    <div class="section__content">
      <div class="section__name">
        <h3
          v-if="check_change_name"
          @click="check_change_name = !check_change_name"
        >
          {{ section.name }}
        </h3>
        <input
          type="text"
          v-model="section.name"
          @keyup.enter="changeName"
          @blur="changeName"
          @keyup.esc="removeSection"
          v-else
        />
        <span v-if="!section.new" @click="removeSectionPopup">
          <img
            :src="require(`@/assets/static/images/remove-section.svg`)"
            alt=""
          />
        </span>
      </div>
    </div>
    <div class="section__tasks" v-if="show_tasks">
      <!-- @change="onEndTaskDrop" -->
      <draggable
        :list="section_tasks"
        group="Task"
        @change="onEndTaskDrop"
        @start="drag = true"
        @add="drag = true"
        v-bind="dragOptions"
        class="draggable_tasks"
      >
        <transition-group
          type="transition"
          :name="!drag ? 'list-complete' : null"
          class="draggable_tasks_group"
        >
          <Task
            v-for="task in section_tasks"
            :key="task._id"
            :task="task"
            @change_complete="change_complete"
            :done="task.done"
            :chat_id="chat_id"
            :class="!drag ? 'list-complete__item' : ''"
          />
        </transition-group>
      </draggable>
      <div
        class="section__tasks_no"
        v-if="!section_tasks || section_tasks.length == 0"
      >
        {{ $t("task.drag_drop_tasks") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { EventEmitter } from "../../main";

import draggable from "vuedraggable";
import Task from "./Task";

export default {
  name: "Section",
  props: {
    section: {
      type: Object,
      required: true,
    },
    tasks: {
      type: Array,
    },
    chat_id: [String],
    project_id: [String],
  },
  data() {
    return {
      drag: false,
      check_change_name: true,
      section_tasks: [],
      section_tasks1: [],
      show_tasks: true,
      // project_id: ''
    };
  },
  mounted() {
    if (localStorage.getItem("register_new_user_date")) {
      setTimeout(() => {
        const names = ["Lists", "Chats", "Good luck!"];
        const keys = [
          "first_section_name.lists",
          "first_section_name.chats",
          "first_section_name.good_luck",
        ];
        names.forEach((name, index) => {
          if (this.section.name == name) {
            this.section.name = this.$t(keys[index]);
            this.$socket.emit("IN_RenameSection", {
              project_id: this.project_id,
              section_id: this.section._id,
              section_name: this.section.name,
            });
          }
        });
      }, 500);
    }

    // console.log(this.section_tasks)

    // document.onclick = () => {
    //     console.log(this.showActionBar)
    //     if (this.showActionBar) {
    //         this.showActionBar = false
    //     }
    // }

    // this.project_id = this.tasks[0].project_id

    this.section_tasks = this.tasks[this.section._id];
    this.section_tasks.sort(function (a, b) {
      return a.order - b.order;
    });
    this.section_tasks1 = this.tasks;
    if (this.section.new) {
      this.check_change_name = false;
      this.show_tasks = false;
      setTimeout(() => {
        document
          .querySelector(".section:last-child .section__name input")
          .focus();
      }, 400);
    }
    // EventEmitter.$on('AddTaskSection', (data) => {
    //     this.onEndTaskDrop()
    // })

    EventEmitter.$on("change_sections_task_order_after_filter", (data) => {
      // console.log('Section is changing ' + this.section._id )
      if (data[this.section._id]) {
        let tasks = this.section_tasks;
        tasks.forEach((task) => {
          if (data[this.section._id][task._id]) {
            task.order = data[this.section._id][task._id];
          }
        });

        tasks.sort((a, b) => {
          if (a.order < b.order) {
            return -1;
          } else {
            return 1;
          }
        });
        // console.log('SORTED in seciton.vue');
        // console.log(tasks);

        this.section_tasks = tasks;
      }
    });

    EventEmitter.$on("changeSectionTaskOrder", (data) => {
      if (data) {
        if (data.section_id == this.section._id) {
          let tasks = [];
          data.new_order.forEach((e) => {
            this.section_tasks.forEach((task) => {
              if (task._id == e.task_id) {
                tasks[e.order] = task;
              }
            });
          });
          this.section_tasks = tasks;
        }
      }
    });
    EventEmitter.$on("uncompleteTask_section", (data) => {
      if (data) {
        if (data.section == this.section._id) {
          this.section_tasks.push(data);
        }
      }
    });
    EventEmitter.$on("removeThisSection", (data) => {
      if (data.section_id == this.section._id) {
        this.removeSection(data);
      }
    });
    EventEmitter.$on("removeTaskfromSection", (data) => {
      if (data) {
        if (this.section._id == data.section_id) {
          if (data.evt.removed) {
            let tasks = this.section_tasks;
            tasks.forEach((e, i) => {
              if (e._id == data.evt.removed.element._id) {
                tasks.splice(i, 1);
              }
            });
            this.section_tasks = [];
            this.section_tasks = tasks;
          }
        }
      }
      // console.log(this.section_tasks)
    });
    // EventEmitter.$on('removeTaskfromSection', (data) => {
    //     if (data) {
    //         this.section_tasks.forEach((e, i) => {
    //             if (e._id == data.task_id) {
    //                 this.section_tasks.splice(i, 1)
    //             }
    //         })
    //     }
    // })
    // EventEmitter.$on('RemoveTaskSection', (data) => {
    //     console.log(data)
    //     if (data) {
    //         console.log(data)
    //         if (data.section_id == this.section._id) {
    //             this.section_tasks.forEach((e, i) => {
    //                 if (data.task_id == e._id) {
    //                     this.section_tasks.splice(i, 1)
    //                 }
    //             })
    //         }
    //     }
    // })
    // EventEmitter.$on('changeOrder', () => {

    // })
  },
  computed: {
    ...mapGetters(["get_flag_for_tasks", "get_flag_task_done"]),
    dragOptions() {
      return {
        animation: 300,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
        removeCloneOnHide: true,
      };
    },
  },
  watch: {
    get_flag_task_done() {
      this.onEndTaskDrop({});
    },
    tasks(e) {
      this.section_tasks = e[this.section._id];
      this.section_tasks.sort(function (a, b) {
        return a.order - b.order;
      });
    },
    // get_flag_for_tasks(e) {
    //     setTimeout(() => {
    //         console.log(this.tasks[this.section._id])
    //         this.section_tasks = this.tasks[this.section._id]
    //     }, 500)
    // },
    section_tasks(e) {
      let data = {
        section_id: this.section._id,
        tasks: e,
      };
      EventEmitter.$emit("WatchSectionTasks", data);
    },
  },
  methods: {
    ...mapActions([
      "socket_change_order",
      "socket_completed_task",
      "remove_section_this_user",
    ]),
    ...mapMutations(["remove_section", "change_task_section"]),
    removeSection(data) {
      if (this.section.new) {
        this.$emit("removeSection", data);
      } else {
        this.showActionBar = false;
        this.remove_section_this_user();
        this.$emit("removeSection", data);
        this.remove_section({
          project_id: this.project_id,
          section_id: this.section._id,
          remove_tasks: data.remove_tasks,
        });
        this.change_task_section({
          project_id: this.project_id,
          section_id: this.section._id,
          remove_tasks: data.remove_tasks,
        });
        this.$socket.emit("IN_RemoveSection", {
          project_id: this.project_id,
          section_id: this.section._id,
          remove_tasks: data.remove_tasks,
        });
      }
    },
    removeSectionPopup() {
      let data = {
        type: "section",
        data: {
          text: this.$t("task.messages.delete_section"),
          cancel: this.$t("app.alert.cancel"),
          delete: this.$t("app.alert.delete"),
        },
        list: this.section._id,
      };
      EventEmitter.$emit("OpenPopup", data);
    },
    change_complete({ complete, task_id }) {
      EventEmitter.$emit("change_completes", {
        task_id: task_id,
        complete,
        show: false,
      });

      if (complete) {
        this.section_tasks.forEach((e, i) => {
          if (e._id == task_id) {
            this.section_tasks.splice(i, 1);
          }
        });
      }

      this.socket_completed_task({
        complete,
        task_id: task_id,
        project_id: this.project_id,
        section: true,
      });
    },
    changeName() {
      if (this.section.new) {
        if (this.section.name != "") {
          this.section.name = this.section.name.slice(0, 160);
          this.$socket.emit("IN_AddSection", {
            project_id: this.project_id,
            section_id: this.section._id,
            section_name: this.section.name,
            section_order: this.section.order,
          });
          this.section.new = false;
          this.show_tasks = true;
          this.check_change_name = !this.check_change_name;
        } else {
          this.removeSection({
            section_id: this.section._id,
          });
        }
      } else {
        if (this.section.name != "") {
          this.section.name = this.section.name.slice(0, 160);
          this.$socket.emit("IN_RenameSection", {
            project_id: this.project_id,
            section_id: this.section._id,
            section_name: this.section.name,
          });
          this.check_change_name = !this.check_change_name;
        }
      }
    },
    onEndTaskDrop(evt) {
      setTimeout(() => {
        this.drag = false;
      }, 200);

      let tasks = this.section_tasks;
      let new_order = [];

      tasks.forEach((e, i) => {
        new_order.push({
          task_id: e._id,
          order: i,
          section_id: this.section._id,
        });
      });

      const unique = Array.from(
        new Map(new_order.map((obj) => [obj.task_id, obj])).values()
      );

      const new_order_position = {
        out: true,
        new_order: unique,
        project_id: this.project_id,
        evt: evt,
        section_id: this.section._id,
      };

      this.socket_change_order({ new_order_position, add_global: true });
    },
    removeTaskChangeOrder(evt) {
      if (evt.removed) {
        this.section_tasks.forEach((e, i) => {
          if (e._id == evt.removed.element._id) {
            this.section_tasks.splice(i, 1);
          }
        });
      }
    },
  },
  components: {
    draggable,
    Task,
  },
};
</script>
